import { Instance } from './implementation';
export function $super(instance, superClass) {
    if (superClass === void 0) { superClass = instance.constructor; }
    return new Instance(instance, superClass.prototype);
}
//# sourceMappingURL=snippets.js.map